import { render, staticRenderFns } from "./UserPreferredObjectStore.vue?vue&type=template&id=8d408122&scoped=true&"
import script from "./UserPreferredObjectStore.vue?vue&type=script&lang=js&"
export * from "./UserPreferredObjectStore.vue?vue&type=script&lang=js&"
import style0 from "./UserPreferredObjectStore.vue?vue&type=style&index=0&id=8d408122&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d408122",
  null
  
)

export default component.exports